import React, { PureComponent, Fragment } from "react";
import { formatPrice } from "helpers";
import moment from "moment";
import cx from "classnames";
import { connect } from "redaction";

import { Grid, Cell } from "components/layout/grid";
import Button from "components/ui/Button/Button";
import Box from "components/layout/Box/Box";
import Title from "components/typography/Title/Title";
import Text from "components/typography/Text/Text";

import s from "../FullToolsReport/FullToolsReport.scss";

class PaymentReportByDate extends PureComponent {
  state = {
    node: null,
  };

  componentDidMount() {
    const encodedUri = this.getEncodeUri();
    const link = document.createElement("a");

    link.setAttribute("href", encodedUri);
    link.setAttribute("download", `${this.getTitle()}.csv`);

    document.body.appendChild(link);

    this.setState({ node: link });
  }

  componentWillUnmount() {
    const { node } = this.state;

    document.body.removeChild(node);
  }

  getTitle = () => {
    const { from, to } = this.props;

    const date = `с ${moment(from, "DDMMYYYY").format(
      "DD.MM.YYYY"
    )} по ${moment(to, "DDMMYYYY").format("DD.MM.YYYY")}`;

    return `Отчет: Продажи ${date} с портала smartsarov.ru`;
  };

  getTotals = ({
    total,
    learnTotal,
    schedTotal,
    subscrTotal,
    name = "",
  }) => {
    const result = [];

    if (learnTotal) {
      result.push([`Итого ${name} (обучение):`, "", learnTotal / 100]);
    }

    if (subscrTotal) {
      result.push([`Итого ${name} (абонементы):`, "", subscrTotal / 100]);
    }

    if (schedTotal) {
      result.push([`Итого ${name} (разовые посещения):`, "", schedTotal / 100]);
    }

    if (total) {
      result.push([`Итого ${name}:`, "", total / 100]);
    }

    return result;
  };

  getEncodeUri = () => {
    const {
      statistic: {
        total,
        learnTotal,
        subscrTotal,
        schedTotal,
        subscriptionsByDate,
      },
      toolName,
    } = this.props;

    let encodeData = "data:text/csv;charset=utf-8,\uFEFF";

    const rows = [];

    rows.push([]);

    rows.push([this.getTitle()]);
    rows.push([]);

    rows.push([toolName]);
    rows.push([]);
    rows.push([]);

    rows.push(["", "Дата", "Сумма платежей(руб.)", "Сумма возвратов(руб.)"]);

    Object.keys(subscriptionsByDate).forEach((date) => {
      const {
        transaction: { amount, refundAmount },
      } = subscriptionsByDate[date];
      rows.push([]);
      rows.push([
        "",
        moment(date).format("DD.MM.YYYY"),
        formatPrice(amount, false),
        formatPrice(refundAmount, false),
      ]);
    });

    rows.push([]);
    rows.push(
      ...this.getTotals({
        total,
        learnTotal,
        subscrTotal,
        schedTotal,
      })
    );

    rows.push([]);
    rows.push([]);
    rows.push([]);
    rows.push([]);

    rows.push(["Источник", "https://smartsarov.ru/marketplace/admin/report"]);

    return `${encodeData}${rows
      .map((items) => items.map((item) => String(item || "")).join(";"))
      .join("\n")}`;
  };

  handleButtonClick = () => {
    const { node } = this.state;
    const { onClose } = this.props;

    node.click();
    onClose();
  };

  renderTotals = ({
    total,
    learnTotal,
    schedTotal,
    subscrTotal,
    name = "",
  }) => (
    <Grid columns={1} gutter="md">
      {Boolean(learnTotal) && (
        <Cell size={1}>
          <Text
            semibold
            color="gray"
            message={`Итого ${name} (обучение): ${formatPrice(learnTotal)}`}
          ></Text>
        </Cell>
      )}
      {Boolean(subscrTotal) && (
        <Cell size={1}>
          <Text
            semibold
            color="gray"
            message={`Итого ${name} (абонементы): ${formatPrice(subscrTotal)}`}
          ></Text>
        </Cell>
      )}
      {Boolean(schedTotal) && (
        <Cell size={1}>
          <Text
            semibold
            color="gray"
            message={`Итого ${name} (разовые посещения): ${formatPrice(
              schedTotal
            )}`}
          ></Text>
        </Cell>
      )}
      {Boolean(total) && (
        <Cell className={s.red} size={1}>
          <Text
            semibold
            message={`Итого ${name}: ${formatPrice(total)}`}
          ></Text>
        </Cell>
      )}
    </Grid>
  );

  render() {
    const {
      className,
      titleClassName,
      buttonClassName,
      darkClassName,
      darkestClassName,
      statistic: {
        total,
        learnTotal,
        schedTotal,
        subscrTotal,
        subscriptionsByDate,
      },
      isEmpty,
      toolName,
    } = this.props;

    return (
      <div className={className}>
        <Box pb="md">
          <div className={titleClassName}>{this.getTitle()}</div>
        </Box>
        {isEmpty ? (
          <div>Нет статистики по выбранным условиям</div>
        ) : (
          <Fragment>
            <Box pb="32">
              <Title size="md" message={toolName}></Title>
              {
                <Box pt="16" pb="16">
                  <Grid className={darkClassName} columns={3} gutter="md">
                    <Cell size={1}>Дата</Cell>
                    <Cell size={1}>Сумма платежей, руб.</Cell>
                    <Cell size={1}>Сумма возвратов, руб.</Cell>
                  </Grid>
                  {Object.keys(subscriptionsByDate).map((date, index) => {
                    const {
                      transaction: { amount, refundAmount },
                    } = subscriptionsByDate[date];
                    return (
                      <Fragment key={index}>
                        <Grid
                          className={cx({
                            [darkClassName]: index % 2 !== 0,
                          })}
                          columns={3}
                          gutter="md"
                          ind={index}
                        >
                          <Cell size={1}>
                            {moment(date).format("DD.MM.YYYY")}
                          </Cell>
                          <Cell size={1}>{formatPrice(amount, false)}</Cell>
                          <Cell size={1}>
                            {Boolean(refundAmount)
                              ? formatPrice(refundAmount, false)
                              : "0"}
                          </Cell>
                        </Grid>
                      </Fragment>
                    );
                  })}
                </Box>
              }
              {this.renderTotals({
                total,
                learnTotal,
                schedTotal,
                subscrTotal,
              })}
            </Box>
            <Box pt="24">
              <Button
                className={buttonClassName}
                title="Сохранить в файл"
                green
                onClick={this.handleButtonClick}
              />
            </Box>
          </Fragment>
        )}
      </div>
    );
  }
}

export default connect({
  toolName: (state) => {
    const {
      marketplace: {
        layersNavigation: {
          category,
          tools,
          toolType,
          tool,
          area,
          nomenclature,
        },
      },
    } = state;

    if (category === "sport") {
      const selectedTool = tools.find(({ id }) => id === toolType);

      if (selectedTool) {
        const toolName = selectedTool.name;

        let areaName;
        let areaShortName;

        selectedTool.areas.find(
          ({ id, name, area: { id: areaId, shortName } }) => {
            if (areaId === area && id === tool) {
              areaName = name;
              return (areaShortName = shortName);
            }
          }
        );

        if (areaShortName) {
          return `${areaShortName}`;
        }

        return `${toolName}`;
      }
    }

    return "";
  },
})(PaymentReportByDate);
